import React, {useEffect, useState} from 'react'
import {Link, useNavigate} from "react-router-dom";
import useAuth from "../auth/useAuth";
import {popErrors} from "../utils/message";
import WaitLoading from "../components/loading/WaitLoading";
import {stopEvent, throttle} from "../utils/events";
import {url} from "../utils/urls";
import "../../style/common/_header.scss";
import "../../style/common/_header_whitebg.scss";
import "../../style/common/_menusp.scss";
import CustomInput from "../components/form/CustomInput";
import {searchKeyword} from "../utils/search";
import SideMenuList from "../components/menu/SideMenuList";
import CategoryMenuList from "../components/menu/CategoryMenuList";
import {isEmptyList} from "../utils/objects";

/**
 * ヘッダ
 * @returns {Element}
 * @constructor
 */
const Header = ({
  headerStyle = {},
  headerTopStyle = {},
  headerMiniStyle = {},
  logo,
  mainLogo,
  title = "　",
  useLimitDate = "",
  menus = [],
  pcMenus = [],
  shopMenus = [],
  isWhiteMode = false,
                }) => {
  const { authed, logout, setAuthed, setLottery } = useAuth();
  const navigate = useNavigate();
  const [ logouting, setLogouting ] = useState(false);
  const [isMiniHeader, setMiniHeader] = useState(false)
  const [isSpMenu, setSpMenu] = useState(false);
  const [isCategoryOpen, setCategoryOpen] = useState(false);
  const [isCategoryMiniOpen, setCategoryMiniOpen] = useState(false);
  const [isShowSearchBox, setShowSearchBox] = useState(false);

  const [headerSearch, setHeaderSearch] = useState("");

  /**
   * スマホ用のメニューの表示・非表示
   */
  const handleClickMenu = () => {
    setSpMenu(!isSpMenu);
    return false;
  };

  const handleShowSearch = (e) => {
    setShowSearchBox(!isShowSearchBox);
    stopEvent(e)
    return false;
  };


  /**
   * ログアウト処理
   */
  const handleLogout = (e) => {
    setLogouting(true);
    logout().then(() => {
      setAuthed(false);
      setLottery(false);

      setLogouting(false);
      navigate("/login/");
    }).catch((error) => {
      console.log("headerLogoutError:" + error);
      popErrors(error);
    }).finally(() => {
    });
    stopEvent(e)
  };

  const handleSearch = (e) => {
    navigate(searchKeyword(headerSearch));
    stopEvent(e)
  }

  /**
   * ヘッダ縮小版表示制御
   */
  const toggleMiniHeader = () => {
    window.scrollY > 200
      ? setMiniHeader(true)
      : setMiniHeader(false)
  }

  /**
   * ページ読み込み時の処理
   */
  useEffect(() => {
    // スクロール時に詳細ヘッダと簡易ヘッダを入れ替えるやつ
    const throttleScroll = throttle(toggleMiniHeader, 10);
    window.addEventListener('scroll', throttleScroll);
    return () => window.removeEventListener('scroll', throttleScroll);
  }, []);


  return (
    <div id="headerTop" style={headerStyle}>
      {/*ページ全体ローディング*/}
      {logouting && (
        <WaitLoading addClass="fixed" top="40%"/>
      )}
      <div className="cover"></div>
      {/*メインヘッダ*/}
      <header className="gHeader">
        <div className="header-top" style={headerTopStyle}>
          {(authed && useLimitDate) &&
            <div className="time"
                 style={{
                   color: headerTopStyle?.["color"],
                   border: headerTopStyle?.["border"],
                   backgroundColor: headerTopStyle?.["backgroundColor"]
                 }}
            >ギフト有効期限<span className="roboto">{useLimitDate}</span></div>
          }
          <ul className="hList flex">
            {/*お気に入り*/}
            {authed && <li className="star"><Link to="/favorites/">
              <i className="far fa-star" style={{color: headerTopStyle?.["color"]}}></i></Link></li>}
            <li className="search">
              {/*検索ボタン*/}
              {authed &&
                <a className="icon" href="#" onClick={handleShowSearch}>
                  <i className="fas fa-search" style={{color: headerTopStyle?.["color"]}}/>
                </a>
              }
              {/*検索窓*/}
              <div className="hSearch"
                   style={
                     isShowSearchBox ? {
                       padding: "43px 0",
                       //height: "100vh",
                     } : {
                       padding: 0,
                       height: 0,
                     }
                   }
              >
                <div className="info">
                  <div className="close">
                    <img src={isWhiteMode ? url("/img/common/close_img.png") : url("/img/common/white_close_img.png")} onClick={() => setShowSearchBox(false)} alt=""
                         className="img-fluid"/>
                  </div>
                  <div className="search d-flex flex-row justify-content-center">
                    <CustomInput type="text" placeholder="キーワードを入力してください"
                                 className="form-control border-0 rounded-0 keywords-input"
                                 value={headerSearch}
                                 onEnterKey={handleSearch}
                                 setValue={setHeaderSearch}
                    />
                    <button type={"button"}
                            className="btn btn-secondary btn-sm border-0 rounded-0 rounded-right btn-search"
                            onClick={handleSearch}>
                      <span>検索</span><i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </li>
            {/*ログアウト*/}
            {authed && <li className="pc"><Link to="#" onClick={handleLogout}
                                                style={{color: headerTopStyle?.["color"]}}>ログアウト</Link></li>}
            {/*ログイン*/}
            {!authed &&
              <li className="pc"><Link to={url("/login/")} style={{color: headerTopStyle?.["color"]}}>ログイン</Link>
              </li>}
          </ul>
          {/*カテゴリメニューボタン*/}
          <div className={"hInfo pc" + (isCategoryOpen ? " on" : "")}
               onMouseEnter={() => setCategoryOpen(true)}
               onMouseLeave={() => setCategoryOpen(false)}
          >
            {/*カテゴリメニューPC*/}
            {authed &&
              <CategoryMenuList
                            menus={pcMenus}
                            title1="カテゴリー"
                            idPrefix="head_"
                            style={{backgroundColor: headerTopStyle?.["backgroundColor"]}}
                            titleFontColor={headerTopStyle?.["color"]}
                            fontColor={headerTopStyle?.["color"]}
              />
            }
          </div>
          {/*ハンバーガー スマホ*/}
          <div className={"menu sp" + (isSpMenu ? " on" : "")}
               onClick={handleClickMenu}><span></span><span></span></div>
        </div>

        <div className="title">
          {/*メインロゴ・タイトル*/}
          <span className="en hover">
            <Link to={url("/")}>
              <img src={mainLogo} alt="" />
              <div>{title}</div>
            </Link>
          </span>

        </div>
      </header>
      {/*ミニバージョンヘッダ*/}
      <header className={"gHeader mini on" + (isMiniHeader ? " active" : "")}
              style={headerMiniStyle}>
        <ul className="hList flex">
          {/*お気に入り*/}
          {authed && <li className="star"><Link to="/favorites/">
            <i className="far fa-star" style={{color: headerMiniStyle?.["color"]}} ></i></Link></li>}
          {/*検索*/}
          {authed &&
            <li className="search">
              <a className="icon" href="#" onClick={handleShowSearch}>
                <i className="fas fa-search" style={{color: headerMiniStyle?.["color"]}} /></a>
            </li>
          }
          {/*ログアウト*/}
          {authed && <li className="pc"><Link to="#" onClick={handleLogout}
                                              style={{color: headerMiniStyle?.["color"]}}>ログアウト</Link></li>}
          {/*ログイン*/}
          {!authed && <li className="pc"><Link to={url("/login/")}
                                               style={{color: headerMiniStyle?.["color"]}}>ログイン</Link></li>}
        </ul>
        <div className={"hInfo pc" + (isCategoryMiniOpen ? " on" : "")}
             onMouseEnter={() => setCategoryMiniOpen(true)}
             onMouseLeave={() => setCategoryMiniOpen(false)}
        >
          {/*カテゴリメニューPC*/}
          {authed &&
            <CategoryMenuList
              menus={pcMenus}
              title1="カテゴリー"
              idPrefix="head_"
              style={{backgroundColor: headerTopStyle?.["backgroundColor"]}}
              titleFontColor={headerTopStyle?.["color"]}
              fontColor={headerTopStyle?.["color"]}
            />
          }
        </div>
        <div className="logo">
          {/*ロゴ*/}
          <Link to="/"><img src={logo} alt=""/></Link>
          {/*有効期限*/}
          {(authed && useLimitDate) &&
            <div className="time pc"
                 style={{color: headerMiniStyle?.["color"], border: headerMiniStyle?.["border"]}}>ギフト有効期限<span className="roboto">{useLimitDate}</span></div>
          }
        </div>
        {/*ハンバーガー スマホ*/}
        <div className={"menu sp" + (isSpMenu ? " on" : "")} onClick={handleClickMenu}><span></span><span></span></div>
      </header>
      {/*SP用メニュー*/}
      <div className={"menuBox" + (isSpMenu ? " on" : "")}>
        <div className="menuInfo">
          {/*ログアウト*/}
          {authed && <div className="logout"><Link to="#" onClick={handleLogout}>ログアウト</Link></div>}
          {/*ログイン*/}
          {!authed && <div className="logout"><Link to={url("/login/")}>ログイン</Link></div>}
          {/*カテゴリメニュー*/}
          {(authed && !isEmptyList(menus)) &&
            menus.map((menu) => {
              return (
              <SideMenuList menus={menu["children"]}
                            key={menu["id"]}
                            title1={menu.title1}
                            title2={menu.title2}
                            style={menu.style}
                            titleClassname="menuTtl"
                            ulClassName="menuList"
                            idPrefix="sp_"/>
              )
            })
          }
          {/*店舗メニュー*/}
          <SideMenuList menus={shopMenus} ulClassName="menuUl" idPrefix="sp_" />
        </div>
      </div>
    </div>
  )
};
export default Header;